import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import "./PackageForm.css"

const PackageTermsandCondition = ({ packageId }) => {
  const initialFieldValues = {
    packageTermsAndConditionId: "00000000-0000-0000-0000-000000000000",
    packageId: packageId || "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    title: "",
    description: "",
  };
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const GetData = async () => {
    const res = await apiService.get(
      `${config.GETTERMSBYPACKAGEID}/${packageId}`
    );
    console.log(res);
    setLists(res.data);
  };

  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPACKAGETERMS, itemToDelete);
        await GetData();
      } catch (error) {
        // Error toast already handled by apiService
      }
      handleCloseDeleteModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.title = values.title === "" ? false : true;
    temp.description = values.description === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        packageTermsAndConditionId: values.packageTermsAndConditionId,
        packageId: packageId,
        title: values.title,
        description: values.description,
        userId: user?.id,
      };
      console.log("Submitting form data:", formData);
      try {
        const isNew =
          formData.packageTermsAndConditionId ===
          "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEPACKAGETERMS, formData);
        } else {
          await apiService.update(config.UPDATEPACKAGETERMS, formData);
        }
        await GetData();
        resetForm();
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setRecordForEdit(null);
    setBtnLoading(false);
    setErrors({});
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

   useEffect(() => {
    if (packageId) {
      GetData();
    }
  }, [packageId]);
 return (
    <div className="PackageTerms-wrapper">
      <div className="PackageTerms-card card">
        <div className="card-body">
          <h5 className="mb-4">Terms & Conditions</h5>

          {/* List */}
          <div className="PackageTerms-list">
            {lists.length > 0 ? (
              lists.map((item) => (
                <div
                  key={item.packageTermsAndConditionId}
                  className="PackageTerms-list-item"
                >
                  {recordForEdit?.packageTermsAndConditionId === item.packageTermsAndConditionId ? (
                    // --- CHANGED: INLINE EDIT FORM ---
                    <div className="row g-2 align-items-center">
                      <div className="col-md-3">
                        <input
                          type="text"
                          name="title"
                          value={values.title}
                          onChange={handleInputChange}
                          className={"form-control " + applyErrorClass("title")}
                          placeholder="Title"
                        />
                      </div>
                      <div className="col-md-7">
                        <input
                          type="text"
                          name="description"
                          value={values.description}
                          onChange={handleInputChange}
                          className={"form-control " + applyErrorClass("description")}
                          placeholder="Description"
                        />
                      </div>
                      <div className="col-md-2 d-flex">
                        <button className="btn btn-success me-2" onClick={handleSubmit}>
                          <i className="ri-check-line"></i>
                        </button>
                        <button className="btn btn-secondary" onClick={resetForm}>
                          <i className="ri-close-line"></i>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="flex-grow-1">
                        <strong>{item.title}</strong> - {item.description}
                      </div>
                      <div className="item-actions">
                        <button className="PackageInclude-action-btn edit" onClick={() => showEditDetails(item)}>
                          <i className="ri-pencil-fill"></i>
                        </button>
                        <button className="PackageInclude-action-btn delete" onClick={() => handleOpenDeleteModal(item.packageTermsAndConditionId)}>
                          <i className="ri-delete-bin-fill"></i>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <p className="text-muted text-center py-3">No terms and conditions added yet. Add one below!</p>
            )}
          </div>

          {/* Add New Row */}
          {recordForEdit === null && (
            // --- CHANGED: ADD NEW FORM ---
            <div className="PackageTerms-add-form mt-4">
                <div className="row g-2 align-items-center">
                    <div className="col-md-3">
                        <input
                            type="text"
                            name="title"
                            value={values.title}
                            onChange={handleInputChange}
                            className={"form-control " + applyErrorClass("title")}
                            placeholder="Title"
                        />
                    </div>
                    <div className="col-md-8">
                         <input
                            type="text"
                            name="description"
                            value={values.description}
                            onChange={handleInputChange}
                            className={"form-control " + applyErrorClass("description")}
                            placeholder="Description"
                        />
                    </div>
                    <div className="col-md-1">
                        <button className="btn btn-success w-100" onClick={handleSubmit} disabled={btnLoading}>
                            {btnLoading ? "..." : <i className="ri-check-line"></i>}
                        </button>
                    </div>
                </div>
            </div>
          )}
        </div>
      </div>

      <DeleteAlert
        show={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default PackageTermsandCondition;